import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { OnDataRetrieving as mainModule } from './main';
import * as $ from 'jquery';
import * as Config from './config';

declare var require: any;

require('../sass-main/pdc-widget-on-data-retrieving.sass');

export class OnDataRetrieving extends WidgetBase {
    public static _name: string = Config.name;
    public static moduleName: string = Config.moduleName;
    public static group: string = Config.group;
    public static icon: string = Config.icon;
    public static namespace: string = Config.namespace;

    public static load() {
        const def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-on-data-retrieving'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        values['themeNodeIdToExpand'] = Config.themeId;
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(OnDataRetrieving);
